import { ICourse } from '@/shared/ICourse';
import { ColumnDef } from '@tanstack/react-table';

export type AppColumnDef<T> = ColumnDef<T> & { meta?: { defaultVisible?: boolean; } };

export const CourseColumnDefinitions: AppColumnDef<ICourse>[] = [
  { id: "id", header: "ID", meta: { defaultVisible: true }, enableResizing: false },
  { id: "folderName", header: "Identifier", meta: { defaultVisible: true }, enableResizing: true },
  { id: "CourseStep", header: "Step", meta: { defaultVisible: true } },
  { id: "provider", header: "Provider", meta: { defaultVisible: true } },
  { id: "CourseTitle", header: "Title", meta: { defaultVisible: true } },
  { id: "CourseProviderUsers", header: "Provider Users", meta: { defaultVisible: true } },
  { id: "CourseStaffUsers", header: "Staff Users", meta: { defaultVisible: true } },
  { id: "expert", header: "External Reviewer", meta: { defaultVisible: true } },
  { id: "commentSet", header: "Comments", meta: { defaultVisible: true } },
  { id: "modified", header: "Modified", meta: { defaultVisible: true } },
  { id: "earliestDeadlineDate", header: "Deadline", meta: { defaultVisible: true } },
  { id: "step1DraftSubmissionDate", header: "Step 1 Draft Submission", meta: { defaultVisible: false } },
  { id: "step1InternalReviewDate", header: "Step 1 Internal Review", meta: { defaultVisible: false } },
  { id: "step1FinalSubmissionDate", header: "Step 1 Final Submission", meta: { defaultVisible: false } },
  { id: "step2DraftSubmissionDate", header: "Step 2 Draft Submission", meta: { defaultVisible: false } },
  { id: "step2InternalReviewDate", header: "Step 2 Internal Review", meta: { defaultVisible: false } },
  { id: "step2FinalSubmissionDate", header: "Step 2 Final Submission", meta: { defaultVisible: false } },
  { id: "modifiedBy", header: "Modified By", meta: { defaultVisible: true } },
  { id: "CourseSegment", header: "Segment", meta: { defaultVisible: true } },
  { id: "coursePlatformVersion", header: "Platform Version", meta: { defaultVisible: false } },
  { id: "CourseNotice", header: "Notice", meta: { defaultVisible: false } },
];

export const defaultColumnVisibility = CourseColumnDefinitions.reduce((acc, col) => {
  const colId = col.id as string;
  const defaultVisible = (col.meta as any)?.defaultVisible ?? true;
  return { ...acc, [colId]: defaultVisible };
}, {} as Record<string, boolean>);

export const defaultColumnOrder = CourseColumnDefinitions.map(col => col.id as string);
